/*
 * DO NOT EDIT
 * ===========
 * This file was auto-generated.
 * To update run the TypeScript Code Generator in the API.
 */

export enum ReportFormat {
  Pdf = 1,
  Csv = 2,
  Xlsx = 3,
}
